<template>
  <div class="dashboard">
    <h1 class="subheading light--text">Dashboard</h1>
    <v-container grid-list-xs>
      <v-layout row wrap class="my-5">
        <v-flex xs12 md10>
          <Popup @storeAdded="snackbar = true"/>
        </v-flex>
        <v-flex xs12 md2>
          <v-card dark flat class="text-xs-center">
            <v-card-title>Current status</v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Popup from "../../components/Popup";
export default {
  components: { Popup },
  data() {
    return {
      items: [
        {
          title: "Statics",
          data: [
            { name: "Total users", stats: 140 },
            { name: "Total clubs", stats: 30 },
            { name: "", stats: 30 },
            { name: "Total clubs", stats: 30 }
          ]
        },
        {
          title: "Info",
          data: [{ name: "Users", stats: 140 }, { name: "Products", stats: 30 }]
        }
      ]
    };
  }
};
</script>
